<template>
	<div class="container ar">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: { name: 'home' } },
				{ name: $t('links.join-us'), link: {}, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="title">{{ $t('join-us.title') }}</div>
		</div>
		<div class="main">
			<div class="sub-title">{{ $t('join-us.title') }}</div>
			<form @submit.prevent="">
				<div class="name">
					<label for="name">{{ $t('join-us.name') }}</label>
					<input type="text" id="name" />
				</div>
				<div class="last-name">
					<label for="/lastName">{{ $t('join-us.sur') }}</label>
					<input type="text" id="lastName" />
				</div>
				<div>
					<label for="university">{{ $t('join-us.university') }}</label>
					<input type="text" id="university" />
				</div>
				<div>
					<label for="collage">{{ $t('join-us.section') }}</label>
					<input type="text" id="collage" />
				</div>
				<div>
					<label for="degree">{{ $t('join-us.academic-rank') }}</label>
					<input type="text" id="degree" />
				</div>
				<div>
					<label for="mainspeci">{{ $t('join-us.specialty') }}</label>
					<input type="text" id="mainspeci" />
				</div>
				<div>
					<label for="specifspeci">{{ $t('join-us.specific-specialty') }}</label>
					<input type="text" id="specifspeci" />
				</div>
				<div>
					<label for="nationality">{{ $t('join-us.nationally') }}</label>
					<input type="text" id="nationality" />
				</div>
				<div>
					<label for="interests">{{ $t('join-us.interest') }}</label>
					<input type="text" id="interests" />
				</div>
				<div class="contact">{{ $t('join-us.contact') }}</div>
				<div class="mobile">
					<label for="mobile">{{ $t('join-us.mobile') }}</label>
					<input type="text" id="mobile" />
				</div>
				<div class="phone">
					<label for="phone">{{ $t('join-us.phone') }}</label>
					<input type="text" id="phone" />
				</div>
				<div class="whatsapp">
					<label for="whatsapp">{{ $t('join-us.whatsapp') }}</label>
					<input type="text" id="whatsapp" />
				</div>
				<div class="email">
					<label for="email">{{ $t('join-us.email') }}</label>
					<input type="text" id="email" />
				</div>
				<div class="btno">
					<button type="submit">{{ $t('join-us.submit') }}</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '../../components/Breadcrumbs';
export default {
	components: {
		Breadcrumbs,
	},
};
</script>

<style scoped>
.container {
	margin: 50px 0;
}
.container > * {
	margin: 0 50px;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}
.main {
	padding: 50px;
}
.main p {
	text-align: center;
	font-family: changeMedium;
}
.sub-title {
	color: var(--green-color);
	font-size: 24px;
	font-family: changeBold;
	text-align: center;
	margin: 35px 0 10px;
}
form {
	display: grid;
	grid-template-columns: repeat(2, 25vw);
	width: max-content;
	margin: 50px auto;
}
form > div {
	grid-column-start: 1;
	grid-column-end: 3;
	display: flex;
	justify-content: space-between;
}
form > .name {
	grid-column: auto;
}
form > .last-name {
	grid-column: auto;
}
form > .contact {
	grid-column-start: 1;
	grid-column-end: 3;
	font-family: changeBold;
	font-size: 20px;
	padding: 10px 20px;
}
/* form > .mobile {
  grid-column: 1;
} */
form > .mobile,
form > .phone,
form > .whatsapp,
form > .email {
	grid-column: auto;
}
form label {
	width: max-content;
	white-space: nowrap;
	line-height: 35px;
	padding: 0 20px;
	font-family: changeMedium;
}
form input {
	width: 100%;
	height: 35px;
	border: none;
	outline: none;
	border-bottom: 2px solid #eee;
	text-align: center;
}
form input:focus {
	border-bottom: 2px solid var(--green-color);
}
.btno button {
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	color: white;
	font-family: changeBold;
	border: none;
	border-radius: 20px;
	padding: 5px 40px;
	margin: 30px 20px;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.main {
		padding: 50px 0;
	}
	form {
		grid-template-columns: repeat(2, 40vw);
	}
}
@media only screen and (max-width: 575px) {
	form {
		grid-template-columns: repeat(2, 48vw);
	}
	form > div {
		grid-column-start: 1 !important;
		grid-column-end: 3 !important;
		display: flex;
		justify-content: space-between;
	}
	form label {
		padding: 0 10px;
	}
}
</style>
